import PropTypes from 'prop-types';
import useMarkOnMount from './hooks/useMarkOnMount';
import PerformanceMarkPropType from './marks/performanceMarkPropType';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const PerformanceMarker = ({
  children = /*#__PURE__*/_jsx(_Fragment, {}),
  marker,
  metricsAdditionalDimensions,
  skipMetrics = false
}) => {
  useMarkOnMount(marker, metricsAdditionalDimensions, skipMetrics);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
PerformanceMarker.propTypes = {
  marker: PerformanceMarkPropType.isRequired,
  metricsAdditionalDimensions: PropTypes.object,
  children: PropTypes.node,
  skipMetrics: PropTypes.bool
};
export default PerformanceMarker;